export default "__VITE_ASSET__C9wTnM5Z__"